// When a coach replaces an athlete's placeholder email, the server also sends an account-setup
// email. The profile saved either way, so the toast must say whether that email went out.
export const getProfileSaveFeedback = data => {
    if (data?.setupEmailSent === true) {
        return { type: 'success', message: 'Profile updated and account-setup email sent.' };
    }
    if (data?.setupEmailSent === false) {
        return {
            type: 'warning',
            message:
                data.warning ||
                'Profile updated, but the account-setup email could not be sent. Check the email address.'
        };
    }
    return { type: 'success', message: 'Profile updated.' };
};

export const stripSetupEmailStatus = ({ setupEmailSent, warning, ...user }) => user;
